import { render, staticRenderFns } from "./OrderFilters.vue?vue&type=template&id=0b992d38&scoped=true&"
import script from "./OrderFilters.vue?vue&type=script&lang=js&"
export * from "./OrderFilters.vue?vue&type=script&lang=js&"
import style0 from "./OrderFilters.vue?vue&type=style&index=0&id=0b992d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b992d38",
  null
  
)

export default component.exports